import UAParser from 'ua-parser-js';

export function isSafari() {
  try {
    const ua = UAParser(navigator.userAgent);
    const { device } = ua;
    const isDevice = device.model === 'Macintosh';
    return isDevice;
  } catch {
    return false;
  }
  // https://stackoverflow.com/a/31732310/12063161 - other variants
}

export function isIOS() {
  try {
    const ua = UAParser(navigator.userAgent);
    const { device, os } = ua;
    const isiOSDevice = (device.model === 'iPhone' || device.model === 'iPad') && os.name === 'iOS';
    return isiOSDevice;
  } catch {
    return false;
  }
  // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios - other variants
}

export function isMobileTablet() {
  try {
    const ua = UAParser(navigator.userAgent);
    const { device } = ua;
    const isMobileTabletDevice = device.type === 'mobile' || device.type === 'tablet';
    return isMobileTabletDevice;
  } catch {
    return false;
  }
}
